import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { IntegrationFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { SimpleFormContainerProps } from "models/propTypes/integrationsPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import SimpleForm from "./simpleForm";
//#endregion
import * as Yup from "yup";
import { FormFieldConstants } from "utils/constants";
import { FormikProps } from "formik";

const SimpleFormContainer: ForwardRefRenderFunction<FormHandles, SimpleFormContainerProps> = (props, ref) => {
  const [selectedCompany] = useSelector((state: AppState) => [state.auth.selectedCompany]);

  const appData = props.appData as WintSuperkollAPIModel.BaseApp;

  const validationSchema = Yup.object<IntegrationFormTypes.SimpleIntegration>({
    userName: Yup.string().when(
      FormFieldConstants.Integration.SimpleIntegration.IsActive,
      ([isActive], schema: Yup.StringSchema) =>
        isActive ? schema.required(TranslationKeys.Validations.Required) : schema
    ),
    apiKey: Yup.string().when(
      FormFieldConstants.Integration.SimpleIntegration.IsActive,
      ([isActive], schema: Yup.StringSchema) =>
        isActive ? schema.required(TranslationKeys.Validations.Required) : schema
    ),
    isActive: Yup.boolean(),
  });

  const defaultValues: IntegrationFormTypes.SimpleIntegration = {
    userName: selectedCompany.id.toString(),
    isActive: props.isActive,
    apiKey: appData.aPIKey,
  };

  const onApiKeyRefresh = (name: string, updatedValue: any, formikProps: FormikProps<any>) => {
    const { values, setFieldValue } = formikProps;
    setFieldValue(FormFieldConstants.Integration.SimpleIntegration.ApiKey, values.refresh);
  };

  return (
    <SimpleForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={props.handleSubmit}
      isActiveText={props.isActiveText}
      onApiKeyRefresh={onApiKeyRefresh}
    />
  );
};

export default forwardRef(SimpleFormContainer);
